import styles from "./CustomTabs.module.css";

import React from "react";
import { Segmented } from "antd";
import styled from "@emotion/styled";

const CustomTabs = ({ defaultValue, onChange, value, options, style }) => {
  const handleChange = (value) => {
    onChange(value);
  };

  const StyledTabs = styled(Segmented)`
    && .ant-segmented-item-selected {
      background: #e9e9e9 !important;
    }

    ${style}
  `;

  return (
    <StyledTabs
      defaultValue={defaultValue}
      className={styles.tabs_wrap}
      onChange={handleChange}
      options={options}
    />
  );
};

export default CustomTabs;
